/** The kinds of field, by id, as the toolbox, the menus and the sentences name them; their groups; and what a field holds, in words. */
export const kinds = {
  names: {
    'short-answer': 'Short answer',
    paragraph: 'Paragraph',
    'multiple-choice': 'Multiple choice',
    checkboxes: 'Checkboxes',
    dropdown: 'Dropdown',
    rating: 'Rating',
    scale: 'Linear scale',
    number: 'Number',
    date: 'Date',
    'date-time': 'Date and time',
    time: 'Time',
    'yes-no': 'Yes or no',
    tick: 'Tick box',
    email: 'Email',
    phone: 'Phone',
    'one-time-code': 'One-time code',
    file: 'File upload',
    signature: 'Signature',
    slider: 'Slider',
    tags: 'Tags',
    'image-choice': 'Image choice',
    ranking: 'Ranking',
    matrix: 'Matrix',
    address: 'Address',
    repeating: 'Repeating group',
    link: 'Link to a record',
    links: 'Links to records',
    lines: 'Table of lines',
    amount: 'Amount',
    progress: 'Progress',
    status: 'Status steps',
    'rich-text': 'Rich text',
    code: 'Code',
    vscode: 'VS Code editor',
    keywords: 'Keywords',
    website: 'Website',
    image: 'Image',
    photos: 'Photo set',
    priority: 'Priority stars',
    'state-dot': 'State dot',
    duration: 'Hours and minutes',
    percentage: 'Percentage',
    timer: 'Timer',
    'date-range': 'Range of dates',
    'booking-slots': 'Booking slots',
    repeat: 'Repeat rule',
    'opening-hours': 'Opening hours',
    colour: 'Colour',
    copy: 'Text to copy',
    pdf: 'PDF shown inline',
    embed: 'Page shown inline',
    'qr-code': 'QR code',
    barcode: 'Barcode',
    pins: 'Pins on a picture',
    distribution: 'Analytic distribution',
    'tax-totals': 'Tax totals',
    payments: 'Payments',
    properties: 'Properties',
  },
  /** The toolbox's groups, by their key. */
  groups: {
    Text: 'Text',
    'Numbers and dates': 'Numbers and dates',
    Choices: 'Choices',
    Records: 'Records',
    More: 'More',
    Business: 'Business',
    'Your kinds': 'Your kinds',
  },
  /** What a field holds, by its type, as a refusal or a tile explains it. */
  stored: {
    char: 'text',
    text: 'long text',
    html: 'rich text',
    selectionMany: 'several of a list',
    selectionOne: 'one of a list',
    integer: 'a whole number',
    float: 'a number',
    monetary: 'an amount',
    date: 'a date',
    datetime: 'a date and time',
    boolean: 'yes or no',
    binary: 'a file',
    image: 'an image',
    many2one: 'a link to a record',
    many2many: 'links to records',
    one2many: 'lines',
    matrix: 'answers in rows',
    json: 'structured data',
    other: 'its own kind of data',
  },
  /** A field of the model refused a kind: what it holds, and the kinds it can be shown as. */
  onlyShownAs: (label: string, stored: string, kinds: string) => `${label} is stored as ${stored} in the model, so it can only be shown as ${kinds}`,
  /** "A, B or C". */
  orList: (words: readonly string[]) => (words.length < 2 ? words.join('') : `${words.slice(0, -1).join(', ')} or ${words[words.length - 1]}`),
};
